import BaseScenesPermissions from 'models/Permissions/BaseScenesPermissions'

class MultiquoteCommercePermissions extends BaseScenesPermissions {}

export default MultiquoteCommercePermissions
